import { useCallback } from 'react';
import { usePermissionContext } from './permissionContext';
import { can, canAction, canAny, canAll } from './can';

export function usePermission() {
  const { permissionMap, isReady } = usePermissionContext();

  return {
    isReady,
    hasPermission: useCallback(
      (key: string) => can(permissionMap, key),
      [permissionMap],
    ),
    hasActionPermission: useCallback(
      (key: string, action: string) => canAction(permissionMap, key, action),
      [permissionMap],
    ),
    hasAnyPermission: useCallback(
      (keys: string[]) => canAny(permissionMap, keys),
      [permissionMap],
    ),
    hasAllPermissions: useCallback(
      (keys: string[]) => canAll(permissionMap, keys),
      [permissionMap],
    ),
  };
}